import { memo } from 'react'

const WhatsAppIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M19.085 4.91a9.871 9.871 0 0 0-3.228-2.16A9.913 9.913 0 0 0 12.04 2c-5.487 0-9.96 4.45-9.96 9.91a9.9 9.9 0 0 0 1.327 4.95L2 22l5.276-1.38c1.458.79 3.096 1.21 4.764 1.21 5.488 0 9.96-4.45 9.96-9.91 0-2.65-1.035-5.14-2.915-7.01ZM12.04 20.15c-1.487 0-2.945-.4-4.22-1.15l-.302-.18-3.136.82.834-3.04-.2-.31a8.23 8.23 0 0 1-1.267-4.38c0-4.54 3.718-8.24 8.281-8.24 2.211 0 4.292.86 5.85 2.42a8.144 8.144 0 0 1 2.422 5.83c.02 4.54-3.699 8.23-8.262 8.23Zm4.543-6.16c-.251-.12-1.477-.72-1.699-.81-.23-.08-.392-.12-.562.12-.171.25-.644.81-.784.97-.141.17-.292.19-.543.06-.251-.12-1.055-.39-2-1.23-.744-.66-1.236-1.47-1.387-1.72-.14-.25-.02-.38.11-.51.111-.11.252-.29.373-.43.12-.14.17-.25.25-.41.081-.17.04-.31-.02-.43s-.562-1.34-.763-1.84c-.201-.48-.412-.42-.563-.43h-.482c-.171 0-.433.06-.664.31-.22.25-.864.85-.864 2.07 0 1.22.894 2.4 1.015 2.56.12.17 1.759 2.67 4.251 3.74a12.2 12.2 0 0 0 1.417.52c.593.19 1.136.16 1.568.1.483-.07 1.478-.6 1.679-1.18.21-.58.21-1.07.14-1.18-.07-.11-.22-.16-.472-.28Z"
    />
  </svg>
)

export default memo(WhatsAppIcon)
